export default __webpack_public_path__ + "static/media/February2009.978975ce.png";